import PropTypes from "prop-types"

import SimpleLineChart from "../simple_line_chart"
import RatingsOverview from "./ratings_overview"
import appletMetricsFetcher from "./applet_metrics_fetcher"
import PeriodSelectionHOC from "../period_selection_hoc"
import { reduceSeriesToValue, computeChangeThisPeriod } from "../lib"

import "../stats.scss"

const AppletMetrics = ({
  data: {
    serviceModuleName,
    metrics,
    ratings,
    suggestedAppletQueryParams,
    slug,
  },
  timePeriodInDays,
  serviceName,
  newAppletPath,
  profileUrl,
}) => (
  <div styleName="stats-container applet">
    <div styleName="grouped-charts">
      <SimpleLineChart
        chartTitle={`Applet enables`}
        data={metrics}
        currentValue={reduceSeriesToValue(
          metrics,
          timePeriodInDays,
          "enables_daily"
        )}
        changeRate={computeChangeThisPeriod(
          metrics,
          timePeriodInDays,
          "enables_daily"
        )}
        metric={"enables_daily"}
        units={"enables"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of enables for ${
          slug ? `this Applet` : `${serviceName} Applets`
        } in the last ${timePeriodInDays} days`}
      />
      <SimpleLineChart
        chartTitle={`Applet disables`}
        data={metrics}
        lowerIsBetter
        currentValue={reduceSeriesToValue(
          metrics,
          timePeriodInDays,
          "disables_daily"
        )}
        changeRate={computeChangeThisPeriod(
          metrics,
          timePeriodInDays,
          "disables_daily"
        )}
        metric={"disables_daily"}
        units={"disables"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of disables for ${
          slug ? `this Applet` : `${serviceName} Applets`
        } in the last ${timePeriodInDays} days`}
      />
      <SimpleLineChart
        chartTitle={`Applet run success rate`}
        data={metrics}
        currentValue={(function () {
          const success = reduceSeriesToValue(
            metrics,
            timePeriodInDays,
            "successful_runs_daily"
          )
          const fail = reduceSeriesToValue(
            metrics,
            timePeriodInDays,
            "unsuccessful_runs_daily"
          )
          return (100 * success) / (success + fail) || 0
        })()}
        precision={0}
        isPercentage
        changeRate={computeChangeThisPeriod(
          metrics,
          timePeriodInDays,
          "run_success_rate_daily"
        )}
        metric={"run_success_rate_daily"}
        units={"percent"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Ratio of successful to total runs for ${
          slug ? `this Applet` : `${serviceName} Applets`
        } in the last ${timePeriodInDays} days`}
      />
      <SimpleLineChart
        chartTitle={`Successful Applet runs`}
        data={metrics}
        currentValue={reduceSeriesToValue(
          metrics,
          timePeriodInDays,
          "successful_runs_daily"
        )}
        changeRate={computeChangeThisPeriod(
          metrics,
          timePeriodInDays,
          "successful_runs_daily"
        )}
        metric={"successful_runs_daily"}
        units={"runs"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of successful runs for ${
          slug ? `this Applet` : `${serviceName} Applets`
        } in the last ${timePeriodInDays} days`}
      />
      <SimpleLineChart
        chartTitle={`Unsuccessful Applet runs`}
        data={metrics}
        lowerIsBetter
        currentValue={reduceSeriesToValue(
          metrics,
          timePeriodInDays,
          "unsuccessful_runs_daily"
        )}
        changeRate={computeChangeThisPeriod(
          metrics,
          timePeriodInDays,
          "unsuccessful_runs_daily"
        )}
        metric={"unsuccessful_runs_daily"}
        units={"runs"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of unsuccessful runs for ${
          slug ? `this Applet` : `${serviceName} Applets`
        } in the last ${timePeriodInDays} days`}
      />
    </div>
    <RatingsOverview
      serviceModuleName={serviceModuleName}
      appletSlug={slug}
      likes={ratings.likes}
      dislikes={ratings.dislikes}
      positiveRatingPercentage={ratings.positiveRatingPercentage}
      negativeRatingPercentage={ratings.negativeRatingPercentage}
      opinionCodes={ratings.opinionCodes}
      newAppletPath={newAppletPath}
      suggestedAppletQueryParams={suggestedAppletQueryParams}
      profileUrl={profileUrl}
    />
  </div>
)

AppletMetrics.propTypes = {
  data: PropTypes.shape({
    serviceModuleName: PropTypes.string,
    metrics: PropTypes.arrayOf(PropTypes.object),
    ratings: PropTypes.object,
    suggestedAppletQueryParams: PropTypes.string,
    slug: PropTypes.string,
  }),
  timePeriodInDays: PropTypes.number,
  serviceName: PropTypes.string.isRequired,
  newAppletPath: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
}

export default PeriodSelectionHOC({
  WrappedComponent: AppletMetrics,
  serviceMetricsFetcher: appletMetricsFetcher,
})
